import { container } from '../../../DataDomain';
import { ICmsConfigurationResponse } from '../../../entity/interface/iCmsConfiguration';
import { ICmsRepository } from '../../repositories/interfaces/iCmsRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetDetailsConfigurationUseCase {
    execute(): Promise<ICmsConfigurationResponse['data']>;
}

export class GeDetailsConfigurationUseCase implements IGetDetailsConfigurationUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get cmsRepository(): ICmsRepository {
        return container.resolve<ICmsRepository>(DI.REPOSITORIES.ICmsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<ICmsConfigurationResponse['data']> {
        const response = await this.cmsRepository.getConfiguration();
        return response.data;
    }
}
